import { FC, useState } from "react";
import {
  Box,
  Button,
  Container,
  Grid,
  Typography,
  makeStyles,
  useMediaQuery,
} from "@material-ui/core";
import { useHistory } from "react-router";

import theme, { Colors } from "../../helpers/theme";

import BuyGainModel from "../Modals/BuyGainModel";

import BuyGains from "../../assets/images/buy_gains.svg";
import StakeGains from "../../assets/images/stake_gains.svg";
import CompleteKYC from "../../assets/images/complete_kyc.svg";
import ApplyWhitelist from "../../assets/images/apply_whitelist.svg";
import NoiseBg from "../../assets/images/noise.png";

const KycStyle = makeStyles((theme) => ({
  kycSection: {
    width: "100%",
    backgroundSize: "cover",
    background:
      "linear-gradient(106.46deg, #00232B -1.01%, #41A0AD 37.69%, #68C9B1 76.38%, #5EFFB1 115.08%)",
    position: "relative",
    "&::before": {
      position: "absolute",
      content: '""',
      width: "100%",
      height: "100%",
      top: 0,
      left: 0,
      backgroundSize: "cover",
      pointerEvents: "none",
      backgroundImage: `url(${NoiseBg})`,
    },
    padding: "5rem 0",
    [theme.breakpoints.down("xs")]: {
      padding: theme.spacing(4, 0),
    },
  },
  buttonStyles: {
    "& .MuiButton-label": {
      fontWeight: 400,
    },
  },
}));

const KycSection: FC<any> = () => {
  const isActive = useMediaQuery(theme.breakpoints.down("sm"));
  const classes = KycStyle();
  const history = useHistory();

  const [open, setOpen] = useState<boolean>(false);

  return (
    <Box className={classes.kycSection}>
      <Container>
        <Box>
          <Box textAlign="center" mb={"3.75rem"}>
            <Typography variant="h2" color="primary">
              {" "}
              <Typography
                component="span"
                className="aspekta-regular white"
                style={{ fontSize: isActive ? "28px" : "40px" }}
              >
                <span className="aspekta-semiBold">
                  Start supporting projects
                </span>
              </Typography>
              <br />
            </Typography>
          </Box>
          <Grid
            container
            justifyContent="space-between"
            alignItems="center"
            direction={isActive ? "column" : "row"}
            style={{ marginTop: "20px" }}
          >
            <Grid item style={{ textAlign: "center" }} lg={3}>
              <Box style={{ minHeight: "150px" }}>
                <img src={BuyGains} width={150} alt="" />
              </Box>
              <Typography
                style={{
                  textAlign: "center",
                  marginTop: "10px",
                  color: Colors.white,
                }}
                display="block"
                className="aspekta-semiBold"
              >
                1. Subcription
              </Typography>
              <Typography
                className="aspekta-regular"
                style={{
                  fontSize: "16px",
                  textAlign: "center",
                  marginTop: "10px",
                  color: Colors.white,
                }}
                display="block"
              >
                Join early
                <br /> stage projects
              </Typography>
            </Grid>
            <Grid
              item
              style={{
                textAlign: "center",
                marginTop: isActive ? "30px" : "0px",
              }}
              lg={3}
            >
              <Box style={{ minHeight: "150px" }}>
                <img src={CompleteKYC} width={150} alt="" />
              </Box>
              <Typography
                style={{
                  textAlign: "center",
                  marginTop: "10px",
                  color: Colors.white,
                }}
                display="block"
                className="aspekta-semiBold"
              >
                2. KYC
              </Typography>
              <Typography
                className="aspekta-regular"
                style={{
                  fontSize: "16px",
                  textAlign: "center",
                  marginTop: "10px",
                  color: Colors.white,
                }}
                display="block"
              >
                Pass it in less
                <br />
                than 5 minutes
              </Typography>
            </Grid>
            <Grid
              item
              style={{
                textAlign: "center",
                marginTop: isActive ? "30px" : "0px",
              }}
              lg={3}
            >
              <Box style={{ minHeight: "150px" }}>
                <img src={ApplyWhitelist} width={150} alt="" />
              </Box>
              <Typography
                style={{
                  textAlign: "center",
                  marginTop: "10px",
                  color: Colors.white,
                }}
                display="block"
                className="aspekta-semiBold"
              >
                3. Whitelist
              </Typography>
              <Typography
                className="aspekta-regular"
                style={{
                  fontSize: "16px",
                  textAlign: "center",
                  marginTop: "10px",
                  color: Colors.white,
                }}
                display="block"
              >
                Register for
                <br />
                desired projects
              </Typography>
            </Grid>
          </Grid>
        </Box>
        <BuyGainModel open={open} setOpen={setOpen} />
      </Container>
    </Box>
  );
};

export default KycSection;
